import React, { useEffect, useState } from 'react'
import NavBarGeneral from '../navbar/NavBar'
import { getUserRole, getUserToken, validarUsuario } from '../login/UserController';
import { obtenerEjes, obtenerNovedades, obtenerUnidades, obtenerUnidadesPorEje, obtenerMyData, buscarUnidad } from '../../controlador/index.controller';
import { Carousel, Col, Row, Container, Button, Card, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward, faForward, faPlay, faPause, faMusic, faSearch, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Loading from '../generalComponents/Loading';
import Footer from '../generalComponents/Footer';
import AndroidChat from '../ai/Android.js';

function Home() {

    const rutaArchivos = "https://unit.fasta.org/data";
    useEffect(() => {
        document.title = "Inicio";
        validarUsuario();
        getNovedades()
        getEjes();
        getUnidadesList();
        obtenerMyData()
    }, []);

    const [novedadesCargadas, setNovedadesCargadas] = useState(false);
    const [novedades, setNovedades] = useState();
    const getNovedades = async () => {
        setNovedadesCargadas(false);
        const res = await obtenerNovedades(getUserToken());
        setNovedades(res);
        setNovedadesCargadas(true);
    }

    const [myData, setMyData] = useState(null)
    const getMyData = async () => {
        const res = await obtenerMyData(getUserToken());
        console.log(res)
        setMyData(res);
    }

    const [ejes, setEjes] = useState(null)
    const getEjes = async () => {
        const res = await obtenerEjes(getUserToken());
        console.log(res)
        setEjes(res);
    }

    const [unidades, setUnidades] = useState(null)
    const [unidadesCargadas, setUnidadesCargadas] = useState(false);
    const [showAiModal, setShowAiModal] = useState(false);
    const getUnidadesList = async () => {
        setUnidadesCargadas(false)
        const getUnidades = await obtenerUnidades(getUserToken());
        setUnidadesCargadas(true);
        if (getUnidades.status === 200) {
            const u = await getUnidades.json();
            console.log(u)
           // let arr = u.slice(-8).reverse();
           let arr = u.slice(0, 8);
            arr.map((t, j) => {
                let arrStateImg = []
                t.unidades_secciones.map((r, i) => {
                    let id = r.seccionId;
                    if (imgSecciones[r.seccionId - 1].src == null) {
                        id = imgSecciones[r.seccionId - 1].img;
                    }
                    if (!arrStateImg.includes(id)) {
                        r.img = imgSecciones[id - 1].src;
                        arrStateImg.push(id);
                    } else {
                        if (id != r.seccionId) {
                            r.img = null;
                        }
                    }
                })
            })
            setUnidades(arr)
            console.log(arr)
        } else if (getUnidades.status === 403) {
            window.location.href = "/login";
        }
    };

    const imgSecciones = [
        { id: 1, src: '/img/Caperucitas.png' },
        { id: 2, src: null, img: 1 },
        { id: 3, src: '/img/Herederas.png' },
        { id: 4, src: '/img/Adalides.png' },
        { id: 5, src: null, img: 4 },
        { id: 6, src: '/img/Escuderos.png' },
        { id: 7, src: null, img: 6 },
        { id: 8, src: '/img/Templarios.png' },
        { id: 9, src: null, img: 8 },
    ]

    const SearchBar = () => {

        const handleSearchChange = async () => {
            const chain = document.getElementById(`textSearch`).value;
            window.location.href = `/busqueda?ch=${chain}`;
        };

        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                handleSearchChange()
            }
        };

        return (
            <Col className=''>
                <div className='align-center-vertically '>
                    <div className='mb-1'>
                        <div style={{ display: 'flex', justifyContent: 'center' }} className="searchDiv">
                            <Form.Control
                                className='searchBar fs-14 wi-200'
                                autoComplete="off"
                                id={`textSearch`}
                                placeholder={"Buscar..."}
                                onKeyDown={handleKeyPress}
                            />
                            <div onClick={() => handleSearchChange()} className='ms-2 flex a-center'>
                                <FontAwesomeIcon icon={faSearch} style={{ color: 'grey' }} />
                            </div>

                        </div>
                    </div>
                </div>
            </Col>
        );
    };

    return (
        <>
            <div className='content ps-0 pe-0 d-none d-sm-block'>

                <NavBarGeneral />
                <div className='ps-5 pe-5 pt-3' style={{minHeight:'90vh'}}>
                    <div className="gradientBackTransparent" style={{ marginTop: '70px' }} />

                    <Row className='p-0'>
                        <Col md={12}>
                            <Carousel className="mb-3" interval={7000} style={{position:'relative'}} fade
                            prevIcon={<FontAwesomeIcon icon={faChevronLeft} style={{ color: 'black' }} />}
                            nextIcon={<FontAwesomeIcon icon={faChevronRight} style={{ color: 'black' }} />}>
                                {!novedadesCargadas ?
                                    <div className='flex j-center a-center mt-3' style={{ height: '40vh' }}>
                                        <Loading />
                                    </div>
                                    :
                                    novedades != null && novedades.map((r, i) => r.mostrar && (
                                        <Carousel.Item key={i} style={{ overflow: 'hidden', backgroundColor: '#f0f0f080' }} className='p-2 br-15'>
                                            <div style={{ overflow: 'hidden' }} className='w-100 br-15 flex j-center'>
                                                <img
                                                    className="d-block "
                                                    src={`${rutaArchivos}${r.imagen.uri}`}
                                                    alt=""
                                                    style={{ height: '40vh' }}
                                                />
                                            </div>
                                            <Carousel.Caption className='flex ps-4 pe-4' style={{position:"absolute", left: 0, bottom:0, width:'100%'}}>
                                                <div className='fitContentWidth ps-3 pe-3 fs-20' style={{backgroundColor:"rgb(0 0 0 / 59%)"}}>
                                                     {r.texto && r.texto}
                                                </div>
                                               
                                            </Carousel.Caption>
                                        </Carousel.Item>))}
                            </Carousel>
                        </Col>
                        <Col md={12}>
                            <div className='flex j-center' style={{ columnGap: '20px' }}>
                                {ejes !== null && ejes.length > 0 && ejes.map((r, i) => r.habilitado && (
                                    <Link to={`/eje/?id=${r.id}`}><div className='flex a-center fitContentWidth' style={{ flexDirection: 'column' }}>
                                        <div style={{ borderRadius: '50%', border: '1px solid #dddddd' }} className='p-2 mb-1'>
                                            <img style={{ height: '80px' }} src={`${rutaArchivos}${r.iconoUri}`} />
                                        </div>
                                        <p className='fs-14' style={{ wordWrap: 'normal', width: 'min-content', textAlign: 'center', lineHeight: '19px', color: 'black' }}>{r.nombre}</p>
                                    </div></Link>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    <Container>
                        <Row className='mt-2'>
                            <p className='fw-600 fs-18'>Últimas unidades cargadas</p>
                            {unidades != null && unidadesCargadas ? unidades.map((r, i) => (
                                <Col md={6} className='mb-3'>
                                    <div className=''>
                                        <Link to={`unidad?id=${r.id}`}><Row className='br-15 boxShadow' style={{ maxHeight: '180px', overflow: 'hidden' }}>
                                            <Col md={6} className='ps-3 pt-3 pb-3 flex' style={{ flexDirection: 'column', justifyContent: 'space-between' }}>
                                                <div>
                                                    <div className='fs-14 ps-2 pe-2 gradientBack fitContentWidth' style={{ borderRadius: '10px', color: 'white' }} >
                                                        {r.unidades_ejes[0].eje.nombre}
                                                    </div>
                                                    <p className='fw-600 fs-18 mt-2 mb-1' style={{ color: 'black' }}>{r.nombre}</p>
                                                </div>
                                                <p className='mb-0 fs-14 grey'>{`${"#" + r.etiquetas.split("; ").join(" #")}`}</p>
                                            </Col>
                                            <Col md={6} className='pe-0' style={{ height: '180px', overflow: 'hidden', position: 'relative' }}>
                                                <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={`${rutaArchivos}${r.imagen.uri}`} alt={r.nombre} />

                                                <div style={{ position: 'absolute', bottom: '5px', right: '5px', backgroundColor: '#ffffffed', columnGap: '4px' }} className='p-1 br-15 flex a-center'>
                                                    {r.unidades_secciones.map((s, i) => s.img != null && (
                                                        <img style={{ height: '20px' }} src={s.img} />
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row></Link>
                                    </div>
                                </Col>
                            )) :
                                <div className='flex j-center a-center mt-3'>
                                    <Loading />
                                </div>
                            }
                        </Row>
                    </Container>
                </div>
                <Footer />

                {/* Botón flotante IA */}
                <button
                    type="button"
                    onClick={() => setShowAiModal(true)}
                    style={{
                        position: 'fixed',
                        bottom: 24,
                        right: 24,
                        width: 56,
                        height: 56,
                        borderRadius: '50%',
                        border: 'none',
                        backgroundColor: '#fff',
                        boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                    }}
                >
                    <img src="/img/AI Boton.svg" alt="Asistente IA" style={{ width: 32, height: 32 }} />
                </button>

                <Modal show={showAiModal} onHide={() => setShowAiModal(false)} size="xl" centered>
                    <Modal.Body style={{ padding: 0, position: 'relative', height: '70vh', minHeight: 400 }}>
                        <AndroidChat embedded />
                    </Modal.Body>
                </Modal>
            </div >

            <div className='d-block d-sm-none' style={{ height: '100vh' }}>
                <div style={{ height: '95vh', width: '95vw' }} className="p-3 flex a-center j-center">
                    <Card className='flex j-center gradientBack p-3'>
                        <img style={{ height: '70px' }} src="https://unit.fasta.org/img/logo.png" />

                        <p style={{ textAlign: 'center' }}>Descargá la app</p>

                        <a style={{ textAlign: 'center' }} href="https://play.google.com/store/apps/details?id=com.secdevs.fasta.unit&pcampaignid=web_share" target="blank"><Button variant="light">
                            Google Play Store
                        </Button></a>

                        <a style={{ textAlign: 'center' }} href='https://apps.apple.com/ar/app/unit/id1622199142?l=en-GB'><Button variant="light" className='mt-3'>
                            App Store
                        </Button></a>
                    </Card>
                </div>

            </div>
        </>
    )
}

export default Home